export { VpMediaTable } from './VpMediaTable';



// WEBPACK FOOTER //
// ./src/vp-ui/widgets/VpMediaTable/index.js